import { InputReviewCreate } from "@scrile/api-provider/dist/api/ReviewProvider";
import { UserPublicData } from "@scrile/api-provider/dist/api/UserPublicDataProvider";
import providers from "../../lib/providers";

export default function useController(recipientUser: UserPublicData) {
  const publishReview = async (publicComment: string, rating: number, privateComment?: string) => {
    const publicData: InputReviewCreate = {
      subject: {
        subjectId: recipientUser.id,
        subjectType: "user",
      },
      rating,
      comment: publicComment.trim(),
    };

    const requests = [providers.ReviewProvider.create({ data: publicData })];

    if (privateComment?.trim()) {
      requests.push(
        providers.ReviewProvider.create({
          data: {
            subject: {
              subjectId: recipientUser.id,
              subjectType: "user_private",
            },
            rating,
            comment: privateComment.trim(),
          },
        })
      );
    }

    const [publicReview] = await Promise.all(requests);
    return publicReview;
  };

  return {
    publishReview,
  };
}
